import { Bug, Crown, Flame, Grid2X2, Lock, MapPin, PawPrint, Shield, Sparkles, Users, Zap } from "lucide-react";
import { CRITTERS, DOLOPALS } from "../../data/dolopals";
import { SectionHeading } from "../SectionHeading";

export const trophyProgress = (exp, collection) => {
  const caught = exp.caught || 0;
  const mega = exp.megaKills || 0;
  const streak = exp.daily?.streak || 0;
  const defense = exp.defenseBest || 0;
  const critters = (exp.critters || []).length;
  const shinies = (exp.shinies || []).length;
  const titans = collection.length;
  return [
    { id: "catch-10", name: "SIGNAL SCOUT", need: "CATCH 10 SIGNALS", value: caught, goal: 10, icon: Zap },
    { id: "catch-50", name: "SIGNAL HUNTER", need: "CATCH 50 SIGNALS", value: caught, goal: 50, icon: Zap },
    { id: "catch-100", name: "SIGNAL LEGEND", need: "CATCH 100 SIGNALS", value: caught, goal: 100, icon: Crown },
    { id: "mega-1", name: "MEGA WORM SLAYER", need: "DOWN 1 MEGA WORM", value: mega, goal: 1, icon: Bug },
    { id: "mega-10", name: "MEGA WORM HUNTER", need: "DOWN 10 MEGA WORMS", value: mega, goal: 10, icon: Bug },
    { id: "mega-25", name: "MEGA WORM BANE", need: "DOWN 25 MEGA WORMS", value: mega, goal: 25, icon: Crown },
    { id: "streak-3", name: "STREAK SPARK", need: "HOLD A 3-DAY DROP STREAK", value: streak, goal: 3, icon: Flame },
    { id: "streak-7", name: "STREAK KEEPER", need: "HOLD A 7-DAY DROP STREAK", value: streak, goal: 7, icon: Flame },
    { id: "defense-10", name: "LINE HOLDER", need: "DEFENSE SCORE 10", value: defense, goal: 10, icon: Shield },
    { id: "defense-25", name: "WALL OF DOLO", need: "DEFENSE SCORE 25", value: defense, goal: 25, icon: Shield },
    { id: "critter-10", name: "CRITTER FRIEND", need: "ADOPT 10 CRITTERS", value: critters, goal: 10, icon: PawPrint },
    { id: "critter-50", name: "CRITTER WHISPERER", need: `ADOPT ALL ${CRITTERS.length} CRITTERS`, value: critters, goal: CRITTERS.length, icon: PawPrint },
    { id: "shiny-1", name: "SHINY LUCK", need: "ADOPT A SHINY CRITTER", value: shinies, goal: 1, icon: Sparkles },
    { id: "shiny-5", name: "SHINY MAGNET", need: "ADOPT 5 SHINY CRITTERS", value: shinies, goal: 5, icon: Crown },
    { id: "shiny-sunday", name: "GOLDEN SUNDAY", need: "CATCH A SHINY ON SHINY SUNDAY", value: exp.sundayShinies || 0, goal: 1, icon: Sparkles },
    { id: "roster-full", name: "FULL ROSTER", need: `ADOPT ALL ${DOLOPALS.length} TITANS`, value: titans, goal: DOLOPALS.length, icon: Users },
    { id: "cache-1", name: "CACHE CRACKER", need: "CRACK A TREASURE CACHE", value: exp.treasure ? 1 : 0, goal: 1, icon: MapPin },
    { id: "match-5", name: "MATCH MASTER", need: "REACH ROUND 5 IN CRITTER MATCH", value: exp.matchBest || 0, goal: 5, icon: Grid2X2 },
  ].map((t) => ({ ...t, got: t.value >= t.goal }));
};

export function TrophyWall({ exp, collection }) {
  const TROPHIES = trophyProgress(exp, collection);
  const earned = TROPHIES.filter((t) => t.got).length;
  return (
    <section className="trophy-wall" data-testid="trophy-wall">
      <SectionHeading
        eyebrow="TROPHY WALL // HUNT THEM ALL"
        title="The trophy wall."
        text="Every milestone on the grid, on one shelf. Locked trophies stay dark and whisper what it takes — go earn the light."
      />
      <p className="trophy-count" data-testid="trophy-count">{earned}/{TROPHIES.length} EARNED</p>
      <div className="trophy-grid">
        {TROPHIES.map((t) => {
          const got = t.got;
          const Icon = t.icon;
          return (
            <div key={t.id} className={`trophy-tile ${got ? "is-earned" : ""}`} data-testid={`trophy-${t.id}`}>
              <span className="trophy-icon">{got ? <Icon size={22} /> : <Lock size={20} />}</span>
              <strong>{got ? t.name : "???"}</strong>
              <em>{got ? "EARNED" : t.need}</em>
              {!got && t.goal > 1 ? <small>{Math.min(t.value, t.goal)}/{t.goal}</small> : null}
            </div>
          );
        })}
      </div>
    </section>
  );
}
